import { Link } from "react-router-dom";
import { ArrowRight, EyeOff, Star, Trash2 } from "lucide-react";

const NewTag = () => <span className="rounded-full bg-[#7C5CBF] text-white text-[10px] font-bold px-2 py-0.5" data-testid="playbook-new-tag">New</span>;
const Based = ({ n, what = "times" }) => <span className="text-xs text-mm-muted">Based on {n} {what}</span>;

const Actions = ({ item, onPref, hideOnly }) => (
  <div className="flex items-center gap-1 shrink-0">
    {!hideOnly && (
      <button onClick={() => onPref(item.key, item.pinned ? "none" : "pinned")} className={`p-1.5 rounded-full transition-colors ${item.pinned ? "text-[#D9A400]" : "text-mm-muted hover:text-[#D9A400]"}`}
        aria-label={item.pinned ? "Unpin" : "This really works for me"} title={item.pinned ? "Unpin" : "This really works for me"} data-testid={`playbook-pin-${item.key}`}>
        <Star size={17} className={item.pinned ? "fill-current" : ""} />
      </button>
    )}
    <button onClick={() => onPref(item.key, "hidden")} className="p-1.5 rounded-full text-mm-muted hover:text-mm-primary" aria-label="Not for me" title="Not for me" data-testid={`playbook-hide-${item.key}`}><EyeOff size={16} /></button>
  </div>
);

export const HelperCard = ({ h, onPref }) => (
  <div className={`mm-card p-4 mm-fade-up ${h.pinned ? "ring-2 ring-[#F5D76E]" : ""}`} data-testid={`playbook-helper-${h.key}`}>
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap"><h3 className="font-bold text-lg break-words">{h.title}</h3>{h.new && <NewTag />}</div>
        <p className="text-sm mt-0.5">{h.detail}</p>
        {h.when && <p className="text-sm text-mm-primary font-semibold mt-1" data-testid={`playbook-when-${h.key}`}>Helps most {h.when.text}</p>}
      </div>
      <Actions item={h} onPref={onPref} />
    </div>
    <div className="flex items-center justify-between mt-3">
      <Based n={h.based_on} />
      {h.link && <Link to={h.link} className="inline-flex items-center gap-1 text-sm font-semibold text-mm-primary" data-testid={`playbook-start-${h.key}`}>Start<ArrowRight size={14} /></Link>}
    </div>
  </div>
);

export const IngredientCard = ({ i, onPref }) => (
  <div className={`rounded-3xl p-4 bg-[#E9F6EC] text-[#24452D] mm-fade-up ${i.pinned ? "ring-2 ring-[#F5D76E]" : ""}`} data-testid={`playbook-ingredient-${i.key}`}>
    <div className="flex items-start justify-between gap-2">
      <div><div className="flex items-center gap-2 flex-wrap"><h3 className="font-bold">{i.title}</h3>{i.new && <NewTag />}</div><p className="text-sm mt-0.5">{i.detail}</p></div>
      <Actions item={i} onPref={onPref} />
    </div>
    <div className="mt-2"><Based n={i.based_on} what="days" /></div>
  </div>
);

export const WarningCard = ({ w, onPref }) => (
  <div className="rounded-3xl p-4 bg-[#FFF4DF] text-[#5A4520] mm-fade-up" data-testid={`playbook-warning-${w.key}`}>
    <div className="flex items-start justify-between gap-2">
      <div><div className="flex items-center gap-2 flex-wrap"><h3 className="font-bold">🌤️ {w.title}</h3>{w.new && <NewTag />}</div><p className="text-sm mt-0.5">…{w.detail}</p></div>
      <Actions item={w} onPref={onPref} hideOnly />
    </div>
    <div className="mt-2"><Based n={w.based_on} /></div>
  </div>
);

export const SavedLine = ({ q, onDelete, testPrefix }) => (
  <li className="mm-soft rounded-2xl px-4 py-3 flex items-start justify-between gap-3" data-testid={`${testPrefix}-${q.id}`}>
    <span className="min-w-0 break-words [overflow-wrap:anywhere]" style={{ fontFamily: testPrefix === "playbook-quote" ? "Georgia, serif" : undefined }}>{testPrefix === "playbook-quote" ? `“${q.text}”` : q.text}</span>
    <button onClick={() => onDelete(q.id)} className="text-mm-muted hover:text-mm-error shrink-0" aria-label="Remove" data-testid={`${testPrefix}-delete-${q.id}`}><Trash2 size={15} /></button>
  </li>
);
